/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

import { ICipBusinessSignUpResources } from '../cip-business-sign-up.props.autogenerated';

export interface IBusinessSignUpTermsConditionsInputProps {
    id: string;
    name: string;
    key: string;
    type: string;
    className: string;
    onChange?(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void;
    isVatCheckFirstClickDone?: boolean;
    resources: ICipBusinessSignUpResources;
    isAcceptedTermsAndConditions: boolean;
    isSubmittedPressed: boolean;
}

export const SignUpTermsConditions: React.FC<IBusinessSignUpTermsConditionsInputProps> = ({
    id,
    name,
    key,
    type,
    resources,
    className,
    onChange,
    isAcceptedTermsAndConditions,
    isSubmittedPressed
}) => {
    return (
        <React.Fragment>
            <div className='col-12' key={key}>
                <div className={`${className}__disclaimer ${className}__group-checkbox`}>
                    <input
                        className={`${className}__input-checkbox`}
                        type={type}
                        id={id}
                        name={name}
                        checked={isAcceptedTermsAndConditions}
                        onChange={onChange}
                    />
                    <label htmlFor={id}>{<span dangerouslySetInnerHTML={{ __html: resources.termsAndConditions }} />}</label>
                </div>
            </div>
            {!isAcceptedTermsAndConditions && isSubmittedPressed && (
                <div className='col-12'>
                    <div className='msc-alert msc-alert-danger'>{resources.termsAndConditionsValidate}</div>
                </div>
            )}
        </React.Fragment>
    );
};

export default SignUpTermsConditions;
